
const digest = '295afc89349e88d995585233730d7ce2007d805f69b10e0c49f5e1f65b31440f';
const classes = {"wrapper":"_wrapper_1iqgw_1","item":"_item_1iqgw_7","title":"_title_1iqgw_13","text":"_text_1iqgw_16"};
const css = `._wrapper_1iqgw_1 {
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-family: "Rubik", sans-serif;
}
._wrapper_1iqgw_1 ._item_1iqgw_7 {
  display: flex;
  flex-direction: row;
  gap: 5px;
  font-size: 14px;
}
._wrapper_1iqgw_1 ._item_1iqgw_7 ._title_1iqgw_13 {
  color: grey;
}
._wrapper_1iqgw_1 ._item_1iqgw_7 ._text_1iqgw_16 {
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  